import { render, staticRenderFns } from "./WorkflowDeleteFoldersModal.vue?vue&type=template&id=8220983a&scoped=true"
import script from "./WorkflowDeleteFoldersModal.vue?vue&type=script&lang=js"
export * from "./WorkflowDeleteFoldersModal.vue?vue&type=script&lang=js"
import style0 from "./WorkflowDeleteFoldersModal.vue?vue&type=style&index=0&id=8220983a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8220983a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
